import { createContext } from "react";

const SubjectContext = createContext();

export default SubjectContext;